import * as req from 'api/actions';
import * as c from './constant';

export const getBarangayProfileList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_BARANGAY_PROFILE,
    '/api/v1/administrators/barangay_profiles',
    payload,
    callback
  );

export const getSingleBarangayProfile = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BARANGAY_PROFILE,
    `/api/v1/administrators/barangay_profiles/${id}`,
    payload,
    callback
  );

export const createBarangayProfile = (payload, callback) =>
  req.create(
    c.CREATE_BARANGAY_PROFILE,
    '/api/v1/administrators/barangay_profiles',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBarangayProfile = (id, payload, callback) =>
  req.update(
    c.UPDATE_BARANGAY_PROFILE,
    `/api/v1/administrators/barangay_profiles/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getOtherFeeCodesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_OTHER_FEE_CODES_LIST,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getOrdinanceRevision = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    `/api/v1/bpls/administrator/common/ordinance_revisions`,
    payload,
    callback
  );